export default __webpack_public_path__ + "static/media/letter.9ad411e4.svg";